import { ButtonProps, useToast } from "@chakra-ui/react";
import { BsRecordCircle, BsRecordCircleFill } from "react-icons/bs";
import { useIntl } from "react-intl";

import { RanaButton } from "@nens/ranalib";
import { ScreenRecordingStatus, useScreenRecorder } from "@nens/react/components";

export const ScreenRecordButton = (props: ButtonProps) => {
  const intl = useIntl();
  const toast = useToast();
  const statusUpdateFunction = (status: ScreenRecordingStatus) => {
    if (status === "SAVED")
      toast({
        title: intl.formatMessage({
          id: "screen_record.video_saved.title",
          defaultMessage: "Recording saved",
        }),
        description: intl.formatMessage({
          id: "screen_record.video_saved.description",
          defaultMessage: "The recording can be found in your Downloads folder",
        }),
        status: "success",
        duration: 5000,
        isClosable: true,
      });

    if (status === "TOO_SHORT")
      toast({
        title: intl.formatMessage({
          id: "screen_record.video_too_short",
          defaultMessage: "Video was too short",
        }),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
  };

  const { recording, switchRecordingActive } = useScreenRecorder(statusUpdateFunction);
  return (
    <RanaButton
      title={
        recording
          ? intl.formatMessage({
              id: "screen_record.stop",
              defaultMessage: "Stop screen recording",
            })
          : intl.formatMessage({
              id: "screen_record.start",
              defaultMessage: "Start screen recording",
            })
      }
      onClick={switchRecordingActive}
      variant="tertiary"
      {...props}
    >
      {recording ? <BsRecordCircleFill size={24} /> : <BsRecordCircle size={24} />}
    </RanaButton>
  );
};
